import { DollarSign, TrendingUp, Users, BarChart3 } from 'lucide-react';
import type { FC } from 'react';
import StatCard from '@/components/common/StatCard';
import type { BillingStats } from '@/pages/ops/SubscriptionsDashboardPage';

interface Props {
  stats: BillingStats | undefined;
}

const fmt = (n: number) => n.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

const BillingStatsCards: FC<Props> = ({ stats }) => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
    <StatCard
      title="MRR"
      value={stats ? `${fmt(stats.mrr)} €` : '—'}
      icon={DollarSign}
      iconColor="text-emerald-600 dark:text-emerald-400"
      iconBg="bg-emerald-50 dark:bg-emerald-900/30"
      trend={stats?.mrrGrowth != null ? { value: stats.mrrGrowth, isPositive: stats.mrrGrowth >= 0, label: 'ce mois' } : undefined}
    />
    <StatCard
      title="ARR"
      value={stats ? `${fmt(stats.arr)} €` : '—'}
      icon={TrendingUp}
      iconColor="text-blue-600 dark:text-blue-400"
      iconBg="bg-blue-50 dark:bg-blue-900/30"
    />
    <StatCard
      title="Abonnés actifs"
      value={stats?.activeSubscriptions?.toLocaleString('fr-FR') ?? '—'}
      icon={Users}
      iconColor="text-violet-600 dark:text-violet-400"
      iconBg="bg-violet-50 dark:bg-violet-900/30"
      trend={stats?.newSubscriptionsThisMonth ? { value: stats.newSubscriptionsThisMonth, isPositive: true, label: 'nouveaux' } : undefined}
    />
    <StatCard
      title="Taux de churn"
      value={stats ? `${stats.churnRate}%` : '—'}
      icon={BarChart3}
      iconColor="text-amber-600 dark:text-amber-400"
      iconBg="bg-amber-50 dark:bg-amber-900/30"
    />
  </div>
);

export default BillingStatsCards;
